import React, { useEffect,useState,useRef } from "react";
import { Context, Hooks, XtLocale, Util } from "@xt/xtbase";
const {XtContext,XtAuth} = Context;
const {useTranslation} = Hooks;
const {moment} = Util;
moment.locale("en");
import styles from "./index.module.less";
import {getZendeskNotices} from "@/api/exchange-user";
import { observer } from 'mobx-react-lite';
import notice from "assets/images/home/notice.png";
import notice_dark from "assets/images/home/notice_dark.png";
import moreImg from "assets/images/home/moreImg.png";
import Slider from "react-slick";

const HomeNotice = () => {
  const t = useTranslation();
  const [newsList, setNewsList] = useState([]);
  const [newsListPhone, setNewsListPhone] = useState([]);
  const [appState] = React.useContext(XtContext);
  const {theme} = appState;

  const getnotice = async ()=>{
    try {
      const lang = XtLocale.getZenLan();
      let res = await getZendeskNotices(lang);
      let notices = res.articles || [];
      if (notices.length == 0 && lang != "en-us") {
        res = await getZendeskNotices("en-us");
        notices = res.articles || [];
      }
      handleNotice(notices);
    } catch (error) {
      let res = await getZendeskNotices("en-us");
      handleNotice(res.articles || []);
    }
  }
  const handleNotice = (notices) => {
    if (notices && notices.length) {
      const newsList = notices.slice(0, 5);
      setNewsList(newsList);
      const newsListPhone = newsList.map((n) => {
        return {
          id:n.id,
          content:n.title,
          time: moment(Date.parse(n.edited_at)).format("MM-DD"),
          html_url:n.html_url
        };
      });
      setNewsListPhone(newsListPhone);
    }
  }

  useEffect(()=>{
    getnotice();
  },[]);
  const onMoreNews = ()=>{
    const lang = XtLocale.getZenLan();
    const url = `https://spikex.zendesk.com/hc/${lang}/categories/10304894611993`;
    window.open(url, "_blank");
  }
  const horseRef = useRef();
  const horseAniIter = ()=>{
    var horse = horseRef.current;
    horse.appendChild(horse.removeChild(horse.childNodes[0]));
    return;
    //会闪烁
    // var list = newsListPhone.slice(1,newsListPhone.length);
    // list.push(newsListPhone[0]);
    // setNewsListPhone(list);
  }

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: "linear",
    beforeChange: function(currentSlide, nextSlide) {
      console.log("before change", currentSlide, nextSlide);
    },
    afterChange: function(currentSlide) {
      console.log("after change", currentSlide);
    }
  };

  return newsList.length ?
    <div className={styles["home-notice-container"]}>
    <div className={styles["notice-content"]}>
      {/* <span className={`iconfont iconshouye-gonggao ${styles.iconfont}`}></span> */}
      <img src={theme=="light" ? notice : notice_dark} className={styles["notice-img"]} />
      {/* <div className={styles["horse-light-container"]}>
        <div ref={horseRef} className={styles["horse-light-base"]} onAnimationIteration={horseAniIter}>
          {newsListPhone.map((news)=>{
            return <span className={`${styles["news-item"]} ${styles["font-family-normal"]}`}  key={"homeNotice_phone_"+news.id}>
              <a title="news.title" href={news.html_url} role="button" target="_blank" rel="noopener noreferrer">
                { news.content }
              </a>
              <span className={styles["news-time"]}>{ news.time}</span>
            </span>
          })}
        </div>
      </div> */}
      <div className={styles['slider']}>
        <Slider {...settings}>
          {newsListPhone.map((news,index)=>{
            return (
              <div className={styles['slier-item']} key={"home_notice_"+index}>
                <a href={news.html_url} target="_blank" rel="noopener noreferrer">[{ news.time }] { news.content }</a>
                {/* <span>{ news.time}</span> */}
              </div>
            )
          })}
        </Slider>
      </div>
      
      
      
      {/* <div className={styles["news-box"]}>
        {newsList.map((news)=>{
          return <span className={`${styles["news-item"]} ${styles["font-family-normal"]}`}  key={"homeNotice_"+news.id}>
          <a title="news.title" href={news.html_url} role="button" target="_blank" rel="noopener noreferrer">
            [{ moment(Date.parse(news.edited_at)).format("MM-DD") }]
            { news.title }
          </a>
        </span>
        })}
      </div> */}
      {/* <span className={styles["news-more"]} onClick={onMoreNews}><span className={styles["more-text"]}>{ t("home.more") }</span><img src={moreImg} className={styles["more-img"]} /></span> */}
    </div>
  </div> : <></>;
}
export default observer(HomeNotice);